import { render } from "./f8c28d9e-1777-11eb-8116-00155d01060e.vue?vue&type=template&id=1061df50"
import script from "./f8c28d9e-1777-11eb-8116-00155d01060e.vue?vue&type=script&lang=js"
export * from "./f8c28d9e-1777-11eb-8116-00155d01060e.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__